import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-footer-follow-us-text',
    templateUrl: './footer-follow-us-text.component.html',
    styleUrl: './footer-follow-us-text.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterFollowUsTextComponent {
  public componentData: CmsParagraphComponent;

  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
